/* tslint:disable */
/* eslint-disable */
/**
 * SLOeats API
 * Interal API to the SLOeats platform.
 *
 * The version of the OpenAPI document: 
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface SexReportTimeseries
 */
export interface SexReportTimeseries {
    /**
     * 
     * @type {Date}
     * @memberof SexReportTimeseries
     */
    date: Date;
    /**
     * 
     * @type {number}
     * @memberof SexReportTimeseries
     */
    male: number;
    /**
     * 
     * @type {number}
     * @memberof SexReportTimeseries
     */
    female: number;
    /**
     * 
     * @type {number}
     * @memberof SexReportTimeseries
     */
    unstated: number;
    /**
     * 
     * @type {number}
     * @memberof SexReportTimeseries
     */
    total: number;
}

/**
 * Check if a given object implements the SexReportTimeseries interface.
 */
export function instanceOfSexReportTimeseries(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "date" in value;
    isInstance = isInstance && "male" in value;
    isInstance = isInstance && "female" in value;
    isInstance = isInstance && "unstated" in value;
    isInstance = isInstance && "total" in value;

    return isInstance;
}

export function SexReportTimeseriesFromJSON(json: any): SexReportTimeseries {
    return SexReportTimeseriesFromJSONTyped(json, false);
}

export function SexReportTimeseriesFromJSONTyped(json: any, ignoreDiscriminator: boolean): SexReportTimeseries {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'date': (new Date(json['date'])),
        'male': json['male'],
        'female': json['female'],
        'unstated': json['unstated'],
        'total': json['total'],
    };
}

export function SexReportTimeseriesToJSON(value?: SexReportTimeseries | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'date': (value.date.toISOString()),
        'male': value.male,
        'female': value.female,
        'unstated': value.unstated,
        'total': value.total,
    };
}

